<template lang="pug">
	.project-settings-actions-duplicate(v-if="showed && Project.SelectedProject && Version.SelectedVersion")
		.card
			.card-header
				i.fa.fa-edit
				span Duplicate Project Version
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label(for="prependedInput") Title of new project version
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="duplicate()") Duplicate
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Project } 			from './../../services/Project';
	import { Version } 			from './../../services/Version';
	import { Settings } 		from './../../services/Settings';

	import _ 					from 'lodash';
	import changeCase 			from "change-case";

	export default {
		name: "ProjectVersionActionsDuplicate",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			return {
				title: ''
			}
		},
		methods: {
			collectData() {

				this.title = this.getNextVersionTitle();

			},
			duplicate() {

				Server.sendToSocket({
					DuplicateVersion: {
						projectId: Project.SelectedProject.id,
						versionId: Version.SelectedVersion.id,
						title: this.title
					}
				});

				Broadcast.call("Selected Version Start Duplicating");

				this.hide();

			},
			getNextVersionTitle() {

				if (!Version.SelectedVersion) return '';

				let title_base = changeCase.titleCase(Version.SelectedVersion.codename || Version.SelectedVersion.title || Project.SelectedProject.codename);
				let title_number = 2;

				let title_base_parts = title_base.split(' ');
				let title_base_last_part = title_base_parts[title_base_parts.length-1];

				//Если последняя часть названия это число - уберём его
				if (/^\d+$/.test(title_base_last_part)) {
					title_base = title_base.substr(0, title_base.lastIndexOf(' '));
					title_number = Math.max(parseInt(title_base_last_part) || 0, 2);
				}

				let title = title_base + ' ' + title_number;

				while (_.find(Version.VersionsByProject[Project.SelectedProject.id], version => {return version.title === title})) {

					title_number++;
					title = title_base + ' ' + title_number;

				}

				return title;

			}
		}
	}
</script>


<style lang="sass">

	.project-settings-actions-duplicate
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 220px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

</style>

